import React from "react";
import "./AnalyticCard.css";

const AnalyticCard = ({ title, duration, value, growth, icon, width, unit }) => {
    return (
        <div className="AnalyticsCard" style={{width: width}}>
            <div className="CardRow">
                <div className="CardText">
                    <div className="CardTitle">{title}</div>
                    <div className="CardDuration">{duration}</div>
                </div>
                <img src={icon} alt="icon" className="database-options-icon" />
            </div>

            {value !== "" && value !== null && value !== undefined && !isNaN(Number(value)) ? (
                <div className="CardRow">
                    <div className="CardValue">
                        {
                            Number.isInteger(Number(value)) ?
                                <p>
                                    {value}
                                </p>
                                : Number(value).toFixed(2)
                        }
                        <span>{unit}</span>
                    </div>
                    <div className={`CardGrowth ${growth !== "" ? "positive" : "negative"}`}>
                        {growth}
                    </div>
                </div>
            ) : (
                <div className="analytic-card-value-shimmer-container">
                    <div className="analytic-card-value-shimmer"></div>
                        <div className="analytic-card-status-shimmer"></div>
                </div>
            )}
            
        </div>
    );
};

export default AnalyticCard;